var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-container"},[_c('HomeHeader'),_c('NewsSection'),_c('TechSection'),_c('ProductSection'),_c('CustomerChoice'),_c('PatentSection'),_c('ConsultSection'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }